import { render, staticRenderFns } from "./CalendarPickerOption.vue?vue&type=template&id=0d52a90b&"
import script from "./CalendarPickerOption.vue?vue&type=script&lang=js&"
export * from "./CalendarPickerOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d52a90b')) {
      api.createRecord('0d52a90b', component.options)
    } else {
      api.reload('0d52a90b', component.options)
    }
    module.hot.accept("./CalendarPickerOption.vue?vue&type=template&id=0d52a90b&", function () {
      api.rerender('0d52a90b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/CalendarPickerOption.vue"
export default component.exports